import React from "react";
import { Ticket } from "../../../models/Ticket";
import "./FutureTickets.scss";
import SingleFutureTicketExercise from "./SingleFutureTicketExercise";
import SingleFutureTicketNoExercise from "./SingleFutureTicketNoExercise";
import { isAfter, isEqual, startOfDay } from "date-fns";

interface IProps {
  ticket: Ticket;
  onRefreshTickets: () => void;
}

const SingleFutureTicket: React.FC<IProps> = ({ ticket, onRefreshTickets }) => {
  const isTodayOrLater = (dateNumber: number): boolean => {
    const today = startOfDay(new Date());
    const inputDate = startOfDay(new Date(dateNumber));

    return isEqual(inputDate, today) || isAfter(inputDate, today);
  };

  if (ticket.passtype === 2 && ticket.ticket && isTodayOrLater(ticket.validto)) {
    return (
      <>
        {ticket.exercises[0] ? (
          <SingleFutureTicketExercise ticket={ticket} onRefreshTickets={onRefreshTickets} />
        ) : (
          <SingleFutureTicketNoExercise ticket={ticket} onRefreshTickets={onRefreshTickets} />
        )}
      </>
    );
  }

  return null;
};

export default SingleFutureTicket;
